import { render, staticRenderFns } from "./canvas-poster.vue?vue&type=template&id=605e86ed&scoped=true"
import script from "./canvas-poster.vue?vue&type=script&lang=js"
export * from "./canvas-poster.vue?vue&type=script&lang=js"
import style0 from "./canvas-poster.vue?vue&type=style&index=0&id=605e86ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e86ed",
  null
  
)

export default component.exports